import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/administrators/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/admins' });
  },
});
